<template>
  <header class="tp-topbar">
    <div class="tp-topbar__titles">
      <span class="tp-topbar__title">{{ title }}</span>
      <span class="tp-topbar__subtitle">{{ user?.parkName }}</span>
    </div>
    <div v-if="user" class="tp-topbar__who">
      <span class="tp-topbar__company">{{ user.tenantName }}</span>
      <div class="tp-topbar__avatar" :style="{ backgroundColor: user.avatarColor || '#3b82f6' }">{{ initials }}</div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/services/authStore'

defineProps({ title: { type: String, default: '' } })

const { state } = useAuthStore()
const user = computed(() => state.user)
const initials = computed(() => {
  const source = user.value?.name || user.value?.tenantName || user.value?.email || ''
  return source.split(' ').filter(Boolean).map((s) => s[0]).join('').slice(0, 2).toUpperCase() || '?'
})
</script>

<style scoped>
.tp-topbar {
  display: flex; align-items: center; gap: 12px;
  height: 56px; padding: 0 20px; flex-shrink: 0;
  background: #1e3a5f; border-left: 1px solid rgba(255, 255, 255, 0.08);
}
.tp-topbar__titles { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.tp-topbar__title { font-family: var(--font-display); font-weight: 700; font-size: 15px; color: #fff; line-height: 1.2; }
.tp-topbar__subtitle { font: 400 11px Inter, sans-serif; color: rgba(255, 255, 255, 0.6); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tp-topbar__who { display: flex; align-items: center; gap: 10px; min-width: 0; }
.tp-topbar__company { font: 400 11px Inter, sans-serif; color: rgba(255, 255, 255, 0.7); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; }
.tp-topbar__avatar {
  width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font: 600 11px Inter, sans-serif;
}
@media (max-width: 768px) {
  .tp-topbar { padding: 0 16px; }
  .tp-topbar__company { display: none; }
}
</style>